import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { designModel } from '../model/index';

@Injectable()
export class DesignService {
    private headers = new Headers({
       'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'

        //'Content-Type': 'application/x-www-form-urlencoded charset=UTF-8', 'Accept': 'q=0.8;application/json;q=0.9'
    });
    private designUrl = 'api/design';  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getDesignList(query: any): Promise<designModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.designUrl}/getDesignList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }


    deleteDesign(design_id: any): Promise<designModel> {
        const url = `${this.designUrl}/deleteDesign`;
        return this.http
            .post(url, $.param({ design_id: design_id }), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as designModel)
            .catch(this.handleError);
    }

    addUpdateDesign(designData: any): Promise<designModel> {

        const url = `${this.designUrl}/addUpdateDesign`;

        return this.http
            .post(url, $.param(designData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as designModel)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/design.service.ts